import {
    CompositeFilterDescriptor,
    FilterDescriptor,
    isCompositeFilterDescriptor
} from '@progress/kendo-data-query';
import { GridFilterChangeEvent } from '@progress/kendo-react-grid';
import { IGridFilter } from '../types/portalTypes';

// Convert a Kendo composite filter to your flat IGridFilter[]
export function toGridFilters(
    filter?: CompositeFilterDescriptor
): IGridFilter[] {
    if (!filter || !Array.isArray(filter.filters)) return [];

    const result: IGridFilter[] = [];

    for (const f of filter.filters) {
        // skip nested groups; you said no Composite support
        if (isCompositeFilterDescriptor(f)) continue;

        const fd = f as FilterDescriptor;

        // only accept string fields (skip function fields)
        if (typeof fd.field !== 'string') continue;

        // operator can be string | Function; only keep string operators
        if (typeof fd.operator !== 'string' || fd.operator === '') continue;

        // when value is null/empty string, treat as cleared
        if (fd.value === undefined || fd.value === null || fd.value === '') continue;

        result.push({
            member: fd.field,
            operator: fd.operator,
            value: String(fd.value) // or keep original type if you change IGridFilter.value
        });
    }

    return result;
}